var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6047 20.7563L21.0984 18.2602C21.2753 18.0841 21.4156 17.8748 21.5113 17.6443C21.6071 17.4139 21.6563 17.1667 21.6562 16.9172C21.6562 16.4086 21.457 15.9305 21.0984 15.5719L18.4125 12.8859C18.2364 12.7091 18.0271 12.5688 17.7967 12.473C17.5662 12.3773 17.3191 12.3281 17.0695 12.3281C16.5609 12.3281 16.0828 12.5273 15.7242 12.8859L13.7602 14.85C12.7468 14.3903 11.825 13.7511 11.0391 12.9633C10.2494 12.1775 9.60785 11.2557 9.14531 10.2422L11.1094 8.27813C11.2862 8.10205 11.4265 7.89276 11.5223 7.6623C11.618 7.43183 11.6672 7.18472 11.6672 6.93516C11.6672 6.42656 11.468 5.94844 11.1094 5.58984L8.42578 2.90156C8.24938 2.7245 8.03971 2.58405 7.80883 2.48832C7.57795 2.39259 7.33041 2.34346 7.08047 2.34375C6.57188 2.34375 6.09375 2.54297 5.73516 2.90156L3.24375 5.39297C2.66953 5.96484 2.34375 6.75469 2.34375 7.56563C2.34375 7.73672 2.35782 7.90078 2.38594 8.0625C2.90625 11.2219 4.58672 14.3555 7.11328 16.8844C9.6375 19.4109 12.7688 21.0891 15.9375 21.6164C16.9055 21.7758 17.9016 21.4547 18.6047 20.7563V20.7563Z",
    fill: "#FF704B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.5e0bbc1f4eb9eb85e3228be66eb8d773.svg";
export { ForwardRef as ReactComponent };